import React from 'react'
import { ContainerInfo } from './styled'
import { LineDivider } from '../../../../../../../../Components/CustomUi/LineDivider'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCircleExclamation, faWarning } from '@fortawesome/free-solid-svg-icons'
import { Warning } from '../../../../../../../../Components/CustomUi/warning'

interface Props {
  resultado_inconsistente: number
  dataSafraConsultoria: any[]
  cod_safra_conta: number
  laboratorio_nome: string
  calcarios: any
  chamarModalInconsistencia: () => void
  /** Status da OS: 6/7 (inconsistência) e 8 (erro) também abrem o detalhe. */
  status?: number
}

export const InfoAdicionais: React.FC<Props> = ({
  cod_safra_conta,
  dataSafraConsultoria,
  resultado_inconsistente,
  laboratorio_nome,
  calcarios,
  chamarModalInconsistencia,
  status,
}) => {

  const erro = status === 8
  const temInconsistencia =
    resultado_inconsistente === 1 || status === 6 || status === 7 || erro

  return (
    <ContainerInfo>
      <div className='conteudo'>
        <div>
          <h3
            style={{
              padding: '0',
              margin: '0',
              fontSize: '16px',
              fontWeight: 'bold',
            }}
          >
            Informações adicionais
          </h3>
        </div>
        <LineDivider />
        <Render condition={temInconsistencia}>
          <div className='inconsistencia' onClick={() => chamarModalInconsistencia()}>
            <FontAwesomeIcon
              fontSize={15}
              icon={erro ? faCircleExclamation : faWarning}
              color={erro ? '#ff4d4f' : '#f7e80c'}
            />
            <label
              style={{
                padding: '0',
                marginTop: '2px',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {erro ? 'Resultado com erro' : 'Resultado com inconsistência'}
            </label>
            <FontAwesomeIcon icon={faArrowRight} className='icone__arrow' />
          </div>
        </Render>
        <Render condition={calcarios?.cod_calcario !== calcarios?.cod_calcario_propriedade}>
          <Warning type='warning' style={{ fontSize: '13px' }}>
            Calcário informado da OS diferente do calcário registrado na propriedade!
          </Warning>
        </Render>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <span
            style={{
              padding: '0',
              margin: '0',
              fontSize: '14px',
              fontWeight: '600',
            }}
          >
            Safra Consultoria:
          </span>{' '}
          <p
            style={{
              padding: '0',
              margin: '0',
              fontSize: '12px',
              fontWeight: '400',
            }}
          >
            {dataSafraConsultoria?.find((item) => item?.cod === cod_safra_conta)?.nome}
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <span
            style={{
              padding: '0',
              margin: '0',
              fontSize: '14px',
              fontWeight: '600',
            }}
          >
            Laboratório:
          </span>{' '}
          <p
            style={{
              padding: '0',
              margin: '0',
              fontSize: '12px',
              fontWeight: '400',
            }}
          >
            {laboratorio_nome}
          </p>
        </div>
      </div>
    </ContainerInfo>
  )
}
